var exports = {
  "Kk": "DesktopNotificationNagbar.module__icon___cjNDWG",
  "h_": "DesktopNotificationNagbar.module__description___cjNDWG",
};

module.exports = exports;
